import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=365f17b2&scoped=true"
import script from "./ring.vue?vue&type=script&lang=js"
export * from "./ring.vue?vue&type=script&lang=js"
import style0 from "./ring.vue?vue&type=style&index=0&id=365f17b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f17b2",
  null
  
)

export default component.exports